/**
 * Accessibility (Phase 8): a colour palette for the HUD's sides and bars, captions for sound
 * cues, and a screen-shake scale. These follow the account through the settings sync.
 */
import { PALETTES, type PaletteName } from '@steelwake/shared/progression';

import { Row, Section } from './layout.js';
import { useSettingsStore } from './store.js';

const PALETTE_LABELS: Record<PaletteName, string> = {
  default: 'Mech colours',
  deuteranopia: 'Deuteranopia (red–green, blue vs orange sides)',
  protanopia: 'Protanopia (red–green, blue vs orange sides)',
  tritanopia: 'Tritanopia (blue–yellow, vermilion vs blue sides)',
};

export function AccessibilitySection() {
  const accessibility = useSettingsStore((s) => s.settings.accessibility);
  const update = useSettingsStore((s) => s.update);
  return (
    <Section title="Accessibility">
      <Row label="HUD colour palette">
        <select
          value={accessibility.palette}
          data-testid="palette"
          onChange={(e) =>
            update({
              accessibility: { ...accessibility, palette: e.target.value as PaletteName },
            })
          }
        >
          {PALETTES.map((p) => (
            <option key={p} value={p}>
              {PALETTE_LABELS[p]}
            </option>
          ))}
        </select>
      </Row>
      <Row label="Captions for sound cues">
        <input
          type="checkbox"
          checked={accessibility.captions}
          data-testid="captions"
          onChange={(e) =>
            update({ accessibility: { ...accessibility, captions: e.target.checked } })
          }
        />
      </Row>
      <Row label={`Screen shake · ${String(Math.round(accessibility.screenShake * 100))}%`}>
        <input
          type="range"
          min={0}
          max={1}
          step={0.05}
          value={accessibility.screenShake}
          data-testid="screen-shake"
          onChange={(e) =>
            update({ accessibility: { ...accessibility, screenShake: Number(e.target.value) } })
          }
        />
      </Row>
    </Section>
  );
}
